import { render, staticRenderFns } from "./index.vue?vue&type=template&id=655cc3cd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=655cc3cd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655cc3cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655cc3cd')) {
      api.createRecord('655cc3cd', component.options)
    } else {
      api.reload('655cc3cd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=655cc3cd&scoped=true", function () {
      api.rerender('655cc3cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/inventoryWarning/index.vue"
export default component.exports